import { render, staticRenderFns } from "./ProjectInfoView.vue?vue&type=template&id=12e09b8a&scoped=true"
import script from "./ProjectInfoView.vue?vue&type=script&lang=js"
export * from "./ProjectInfoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e09b8a",
  null
  
)

export default component.exports